<template>
  <div class="decision-order">
    <div v-if="work">
      <div v-for="answer in work.answers" :key="answer.id">
        <div>
                  {{ answer.title }}
          <img v-if="answer.img" :src="answer.img" />
  

          <span class="ml-2 mr-2 badge badge-info">Позиция ученика: {{check(answer)}}</span>
        </div>


      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "text",
  props: {
    work: {
      default: null,
    },
  },
  data() {
    return {

    };
  },
  methods: {
    check(answer) {
      for (let i = 0; i < this.work.decisions.length; i++) {
        if (this.work.decisions[i].answer_id == answer.id) {
          return parseInt(this.work.decisions[i].answer) + 1;
        }
      }
    }
  },
};
</script>


<style lang="scss">
.decision-order {
  img {
    width: 100px;
    height: 100px;
    object-fit: contain;
    margin-right: 10px;
  }
}
</style>

